<ng-template #accessoryBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('product.save-product-first' | translate)
                : ('product.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'product.save-product-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div
    #accessoryBlock
    [class]="'flex min-h-0 flex-1 flex-col w-full overflow-hidden'"
    [blocked]="!model?.id"
    [blockUi]="accessoryBlockUi"
>
    @if (model?.id) {
        <app-accessory-config-product-link-list-widget
            #accessoryConfigProductLinkList
            [autoFocusSearch]="false"
            [product]="productSig()"
            [attr.data-testid]="'accessory-config-product-link-list-widget'"
        ></app-accessory-config-product-link-list-widget>
    }
</blockable-div>
